import { getUrl, sessionExpired } from '../setEnvironment';

class PlcSafetyAPI {
  constructor() {
    this.URL = getUrl();
    this.getZones = this.getZones.bind(this);
    this.getCauses = this.getCauses.bind(this);
    this.getEvents = this.getEvents.bind(this);
    this.getEventById = this.getEventById.bind(this);
    this.createEvent = this.createEvent.bind(this);
    this.updateEvent = this.updateEvent.bind(this);
    this.deleteEvent = this.deleteEvent.bind(this);
    this.getTriggers = this.getTriggers.bind(this);
    this.getTriggerById = this.getTriggerById.bind(this);
    this.createTrigger = this.createTrigger.bind(this);
    this.updateTrigger = this.updateTrigger.bind(this);
    this.deleteTrigger = this.deleteTrigger.bind(this);
    this.getZoneDependencies = this.getZoneDependencies.bind(this);
    this.createZoneDependency = this.createZoneDependency.bind(this);
    this.deleteZoneDependency = this.deleteZoneDependency.bind(this);
    this.getDashboardStats = this.getDashboardStats.bind(this);
  }

  // P01021-139 (Fase 2): widget "Seguridad PLC" del Dashboard.
  async getDashboardStats(token) {
    try {
      const response = await fetch(this.URL + '/plc-safety/dashboardStats', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: token },
      });
      if (sessionExpired(response.status)) return;
      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  async getZones(token) {
    try {
      const response = await fetch(this.URL + '/plc-safety/zones', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: token },
      });
      if (sessionExpired(response.status)) return;
      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  async getCauses(token, size, page, status) {
    try {
      let url = `${this.URL}/plc-safety/causes?size=${size}&page=${page}`;
      if (status) url += `&status=${status}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: token },
      });
      if (sessionExpired(response.status)) return;
      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  async getEvents(token) {
    try {
      const response = await fetch(this.URL + '/plc-safety/events', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: token },
      });
      if (sessionExpired(response.status)) return;
      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  async getEventById(token, id) {
    try {
      const response = await fetch(this.URL + '/plc-safety/events/' + id, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: token },
      });
      if (sessionExpired(response.status)) return;
      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  async createEvent(token, event) {
    try {
      const response = await fetch(this.URL + '/plc-safety/events', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({ ...event }),
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      if (!response.ok) throw new Error(json.message);
      return json;
    } catch (error) {
      throw error;
    }
  }

  async updateEvent(token, id, event) {
    try {
      const response = await fetch(this.URL + '/plc-safety/events/' + id, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({ ...event }),
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      if (!response.ok) throw new Error(json.message);
      return json;
    } catch (error) {
      throw error;
    }
  }

  async deleteEvent(token, id) {
    try {
      const response = await fetch(this.URL + '/plc-safety/events/' + id, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({}),
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      if (!response.ok) throw new Error(json.message);
      return json;
    } catch (error) {
      throw error;
    }
  }

  async getTriggers(token) {
    try {
      const response = await fetch(this.URL + '/plc-safety/triggers', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: token },
      });
      if (sessionExpired(response.status)) return;
      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  async getTriggerById(token, id) {
    try {
      const response = await fetch(this.URL + '/plc-safety/triggers/' + id, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: token },
      });
      if (sessionExpired(response.status)) return;
      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  async createTrigger(token, trigger) {
    try {
      const response = await fetch(this.URL + '/plc-safety/triggers', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({ ...trigger }),
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      if (!response.ok) throw new Error(json.message);
      return json;
    } catch (error) {
      throw error;
    }
  }

  async updateTrigger(token, id, trigger) {
    try {
      const response = await fetch(this.URL + '/plc-safety/triggers/' + id, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({ ...trigger }),
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      if (!response.ok) throw new Error(json.message);
      return json;
    } catch (error) {
      throw error;
    }
  }

  async deleteTrigger(token, id) {
    try {
      const response = await fetch(this.URL + '/plc-safety/triggers/' + id, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({}),
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      if (!response.ok) throw new Error(json.message);
      return json;
    } catch (error) {
      throw error;
    }
  }

  async getZoneDependencies(token) {
    try {
      const response = await fetch(this.URL + '/plc-safety/zone-dependencies', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: token },
      });
      if (sessionExpired(response.status)) return;
      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  async createZoneDependency(token, dependency) {
    try {
      const response = await fetch(this.URL + '/plc-safety/zone-dependencies', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({ ...dependency }),
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      if (!response.ok) throw new Error(json.message);
      return json;
    } catch (error) {
      throw error;
    }
  }

  async deleteZoneDependency(token, id) {
    try {
      const response = await fetch(this.URL + '/plc-safety/zone-dependencies/' + id, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({}),
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      if (!response.ok) throw new Error(json.message);
      return json;
    } catch (error) {
      throw error;
    }
  }
}

let _plcSafetyAPI = null;
const initPlcSafetyAPI = () => {
  if (!_plcSafetyAPI) {
    _plcSafetyAPI = new PlcSafetyAPI();
  }
  return _plcSafetyAPI;
};
const getPlcSafetyAPI = () => initPlcSafetyAPI();

export { initPlcSafetyAPI, getPlcSafetyAPI };
